enum ExpectedMobileErrors {
  NOT_AUTHORISED = 'This number is not authorised to view this message. Request access',
}

export default ExpectedMobileErrors